import { render, staticRenderFns } from "./Scene.vue?vue&type=template&id=84bbaaa6&"
import script from "./Scene.vue?vue&type=script&lang=js&"
export * from "./Scene.vue?vue&type=script&lang=js&"
import style0 from "../stylesheet/common.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "../stylesheet/iconfont.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports